/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfBoolean } from '../../models/platform-api-result-of-boolean';
import { PlatformVerifyUserAccount } from '../../models/platform-verify-user-account';

export interface PostUseraccountsActionVerify$Params {
      body: PlatformVerifyUserAccount
}

export function postUseraccountsActionVerify(http: HttpClient, rootUrl: string, params: PostUseraccountsActionVerify$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
  const rb = new RequestBuilder(rootUrl, postUseraccountsActionVerify.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfBoolean>;
    })
  );
}

postUseraccountsActionVerify.PATH = '/api/useraccounts/action/verify';
